import { AttributeDefinitionValueListItem } from './attributeDefinitionValueListItem';

import * as _ from 'lodash';

export class AttributeMultiValueWrite {
  public attributeDefinitionValueListItemId: string;
  public attributeDefinitionValueListItemValue: string;
  public added: boolean = false;

  constructor(
    attributeDefinitionValueListItemId: string,
    attributeDefinitionValueListItemValue: string,
    added: boolean
  ) {
    this.attributeDefinitionValueListItemId = attributeDefinitionValueListItemId;
    this.attributeDefinitionValueListItemValue = attributeDefinitionValueListItemValue;
    this.added = added;
  }

  static parse(obj: any): AttributeMultiValueWrite {
    return new AttributeMultiValueWrite(
      obj.attributeDefinitionValueListItemId,
      obj.attributeDefinitionValueListItemValue,
      obj.added
    );
  }

  static fromAttributeValueTypeListItem(
    attributeDefinitionValueListItem: AttributeDefinitionValueListItem
  ) {
    return AttributeMultiValueWrite.parse({
      attributeDefinitionValueListItemId: attributeDefinitionValueListItem.id,
      attributeDefinitionValueListItemValue: attributeDefinitionValueListItem.itemValue,
      added: _.isNil(attributeDefinitionValueListItem.id),
    });
  }
}
